import React, { useState } from "react";
import { Helmet } from "react-helmet";
import LoadingSpinner from "../../partials/loading";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { GET_WARD } from "../../queries/ward.query";
import { NEW_ADMISSION } from "../../queries/patient.query";
import auth from "../../providers/Auth.Provider";
import DropdownList from "./partial/DropdownList";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { CleanMessage, AppName } from "../../util/app";
import { sendNotification } from "../../sockette";
import { ReadData } from "../../providers/Patient.Provider";
import { ACTION_TYPE, EVENT_TARGET } from "../../event/model";

function AdmitPatient({ match, history }) {
    const [rooms, setRoom] = useState(null);
    const [ward, setWard] = useState(null);
    const [bed, setBed] = useState(null);
    const [discharge_date, setDischargeDate] = useState(undefined);
    const [admission_date, setAdmissionDate] = useState(new Date());

    // get site from logged in user
    const { GetToken, GetAuthenticatedStaff } = auth.authProvider;
    const {
        site: { id: siteId },
    } = GetToken() && GetAuthenticatedStaff();

    const patient = ReadData();

    // prepare query to fetch wards
    const { loading: ward_loading, data: ward_data } = useQuery(GET_WARD, {
        variables: { page: 1, limit: 100, site: siteId },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    // Prepare mutation for new admission
    const [admitFunc, { loading: admit_loading }] = useMutation(NEW_ADMISSION, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.Admit;
            toast.success(message);
            sendNotification({ ...patient, admitted: true, lastAdmission: d.Admit.doc.id }, ACTION_TYPE.UPDATE, EVENT_TARGET.PATIENT);
            history.push("/home/patient/profile/" + id);
            setTimeout(() => {
                document.location.reload(true);
            }, 500);
        },
    });

    const title = "New InPatient";
    const { id } = match.params;

    return (
        <>
            <Helmet>
                <title>
                    {title} | {AppName}
                </title>
            </Helmet>

            <form
                className="row justify-content-center"
                method="post"
                onSubmit={async (e) => {
                    e.preventDefault();
                    if (bed && admission_date) {
                        await admitFunc({
                            variables: {
                                model: {
                                    patient: id,
                                    admission_date,
                                    discharge_date,
                                    bed: bed.id,
                                },
                            },
                        });
                    }
                }}
            >
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-head">
                            <header>New InPatient</header>
                        </div>
                        <div className="card-body min-height">
                            <div className="row">
                                <div className="col-3 bg-primary text-center">
                                    <h5>Ward Detail</h5>
                                </div>

                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                <strong>Ward *</strong>
                                            </td>
                                            <td>
                                                <div className="col-8">
                                                    <DropdownList title="" items={ward_data ? ward_data.GetWards.docs : []} onSelect={setWard} />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                <strong>Room *</strong>
                                            </td>
                                            <td>
                                                <div className="col-8">
                                                    <DropdownList items={ward ? ward.rooms : []} title="" onSelect={setRoom} />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                <strong>Bed *</strong>
                                            </td>
                                            <td>
                                                <div className="col-8">
                                                    <DropdownList items={rooms ? rooms.beds.filter((c) => !c.taken) : []} title="" onSelect={setBed} />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="row">
                                <div className="col-3 bg-primary text-center">
                                    <h5>Admission Date</h5>
                                </div>

                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                <strong>Admission Date *</strong>
                                            </td>
                                            <td>
                                                <div className="col-8">
                                                    <DatePicker selected={admission_date} onChange={(date) => setAdmissionDate(date)} className="form-control input-height" dateFormat="MMMM d, yyyy" />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                <strong>Discharge Date</strong>
                                            </td>
                                            <td>
                                                <div className="col-8">
                                                    <DatePicker selected={discharge_date} onChange={(date) => setDischargeDate(date)} className="form-control input-height" dateFormat="MMMM d, yyyy" />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <LoadingSpinner loading={ward_loading || admit_loading} />

                            <div style={{ display: "flex" }} className="m-b-10 m-t-20 space-around justify-content-center">
                                <button type="button" onClick={() => history.goBack()} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect btn-circle">
                                    <i className="material-icons text-danger">cancel</i> Cancel
                                </button>
                                &nbsp;&nbsp;
                                <button type="submit" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success">
                                    Submit Form <i className="material-icons">arrow_right_alt</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AdmitPatient;
